// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { decideAction, endViewAs, getCustomer, getDashboard, getPaymentTimeline, getStaffMe, getUser, issueViewAsToken, listActions, listActionTypes, listAllPayments, listBreaks, listOnboardingQueue, listPartnerEvents, listPartners, listReconRuns, listStaff, listViewAs, type Options, provisionStaff, requestAction, resolveBreak, runRecon, searchAudit, searchOrgs, searchUsers, setPartnerOverride, setStaffRoles, setStaffStatus, startViewAs } from '../sdk.gen';
import type { DecideActionData, DecideActionError, DecideActionResponse, EndViewAsData, EndViewAsError, EndViewAsResponse, GetCustomerData, GetCustomerError, GetCustomerResponse, GetDashboardData, GetDashboardError, GetDashboardResponse, GetPaymentTimelineData, GetPaymentTimelineError, GetPaymentTimelineResponse, GetStaffMeData, GetStaffMeError, GetStaffMeResponse, GetUserData, GetUserError, GetUserResponse, IssueViewAsTokenData, IssueViewAsTokenError, IssueViewAsTokenResponse, ListActionsData, ListActionsError, ListActionsResponse, ListActionTypesData, ListActionTypesError, ListActionTypesResponse, ListAllPaymentsData, ListAllPaymentsError, ListAllPaymentsResponse, ListBreaksData, ListBreaksError, ListBreaksResponse, ListOnboardingQueueData, ListOnboardingQueueError, ListOnboardingQueueResponse, ListPartnerEventsData, ListPartnerEventsError, ListPartnerEventsResponse, ListPartnersData, ListPartnersError, ListPartnersResponse, ListReconRunsData, ListReconRunsError, ListReconRunsResponse, ListStaffData, ListStaffError, ListStaffResponse, ListViewAsData, ListViewAsError, ListViewAsResponse, ProvisionStaffData, ProvisionStaffError, ProvisionStaffResponse, RequestActionData, RequestActionError, RequestActionResponse, ResolveBreakData, ResolveBreakError, ResolveBreakResponse, RunReconData, RunReconError, SearchAuditData, SearchAuditError, SearchAuditResponse, SearchOrgsData, SearchOrgsError, SearchOrgsResponse, SearchUsersData, SearchUsersError, SearchUsersResponse, SetPartnerOverrideData, SetPartnerOverrideError, SetPartnerOverrideResponse, SetStaffRolesData, SetStaffRolesError, SetStaffRolesResponse, SetStaffStatusData, SetStaffStatusError, SetStaffStatusResponse, StartViewAsData, StartViewAsError, StartViewAsResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getStaffMeQueryKey = (options?: Options<GetStaffMeData>) => createQueryKey('getStaffMe', options);

export const getStaffMeOptions = (options?: Options<GetStaffMeData>) => queryOptions<GetStaffMeResponse, GetStaffMeError, GetStaffMeResponse, ReturnType<typeof getStaffMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStaffMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStaffMeQueryKey(options)
});

export const getDashboardQueryKey = (options?: Options<GetDashboardData>) => createQueryKey('getDashboard', options);

export const getDashboardOptions = (options?: Options<GetDashboardData>) => queryOptions<GetDashboardResponse, GetDashboardError, GetDashboardResponse, ReturnType<typeof getDashboardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDashboard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDashboardQueryKey(options)
});

export const listStaffQueryKey = (options?: Options<ListStaffData>) => createQueryKey('listStaff', options);

export const listStaffOptions = (options?: Options<ListStaffData>) => queryOptions<ListStaffResponse, ListStaffError, ListStaffResponse, ReturnType<typeof listStaffQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStaff({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStaffQueryKey(options)
});

/**
 * Creates a staff identity and emails them a one-time setup link.
 */
export const provisionStaffMutation = (options?: Partial<Options<ProvisionStaffData>>): UseMutationOptions<ProvisionStaffResponse, ProvisionStaffError, Options<ProvisionStaffData>> => {
    const mutationOptions: UseMutationOptions<ProvisionStaffResponse, ProvisionStaffError, Options<ProvisionStaffData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await provisionStaff({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setStaffRolesMutation = (options?: Partial<Options<SetStaffRolesData>>): UseMutationOptions<SetStaffRolesResponse, SetStaffRolesError, Options<SetStaffRolesData>> => {
    const mutationOptions: UseMutationOptions<SetStaffRolesResponse, SetStaffRolesError, Options<SetStaffRolesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setStaffRoles({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setStaffStatusMutation = (options?: Partial<Options<SetStaffStatusData>>): UseMutationOptions<SetStaffStatusResponse, SetStaffStatusError, Options<SetStaffStatusData>> => {
    const mutationOptions: UseMutationOptions<SetStaffStatusResponse, SetStaffStatusError, Options<SetStaffStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setStaffStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchOrgsQueryKey = (options?: Options<SearchOrgsData>) => createQueryKey('searchOrgs', options);

export const searchOrgsOptions = (options?: Options<SearchOrgsData>) => queryOptions<SearchOrgsResponse, SearchOrgsError, SearchOrgsResponse, ReturnType<typeof searchOrgsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchOrgs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchOrgsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const searchOrgsInfiniteQueryKey = (options?: Options<SearchOrgsData>): QueryKey<Options<SearchOrgsData>> => createQueryKey('searchOrgs', options, true);

export const searchOrgsInfiniteOptions = (options?: Options<SearchOrgsData>) => {
    const opts = infiniteQueryOptions<SearchOrgsResponse, SearchOrgsError, InfiniteData<SearchOrgsResponse>, QueryKey<Options<SearchOrgsData>>, number | Pick<QueryKey<Options<SearchOrgsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<SearchOrgsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await searchOrgs({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchOrgsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getCustomerQueryKey = (options: Options<GetCustomerData>) => createQueryKey('getCustomer', options);

/**
 * Customer 360. Viewing is audited.
 */
export const getCustomerOptions = (options: Options<GetCustomerData>) => queryOptions<GetCustomerResponse, GetCustomerError, GetCustomerResponse, ReturnType<typeof getCustomerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCustomer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCustomerQueryKey(options)
});

export const searchUsersQueryKey = (options: Options<SearchUsersData>) => createQueryKey('searchUsers', options);

export const searchUsersOptions = (options: Options<SearchUsersData>) => queryOptions<SearchUsersResponse, SearchUsersError, SearchUsersResponse, ReturnType<typeof searchUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchUsersQueryKey(options)
});

export const getUserQueryKey = (options: Options<GetUserData>) => createQueryKey('getUser', options);

export const getUserOptions = (options: Options<GetUserData>) => queryOptions<GetUserResponse, GetUserError, GetUserResponse, ReturnType<typeof getUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserQueryKey(options)
});

export const listAllPaymentsQueryKey = (options?: Options<ListAllPaymentsData>) => createQueryKey('listAllPayments', options);

export const listAllPaymentsOptions = (options?: Options<ListAllPaymentsData>) => queryOptions<ListAllPaymentsResponse, ListAllPaymentsError, ListAllPaymentsResponse, ReturnType<typeof listAllPaymentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAllPayments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAllPaymentsQueryKey(options)
});

export const listAllPaymentsInfiniteQueryKey = (options?: Options<ListAllPaymentsData>): QueryKey<Options<ListAllPaymentsData>> => createQueryKey('listAllPayments', options, true);

export const listAllPaymentsInfiniteOptions = (options?: Options<ListAllPaymentsData>) => {
    const opts = infiniteQueryOptions<ListAllPaymentsResponse, ListAllPaymentsError, InfiniteData<ListAllPaymentsResponse>, QueryKey<Options<ListAllPaymentsData>>, number | Pick<QueryKey<Options<ListAllPaymentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListAllPaymentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listAllPayments({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAllPaymentsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getPaymentTimelineQueryKey = (options: Options<GetPaymentTimelineData>) => createQueryKey('getPaymentTimeline', options);

export const getPaymentTimelineOptions = (options: Options<GetPaymentTimelineData>) => queryOptions<GetPaymentTimelineResponse, GetPaymentTimelineError, GetPaymentTimelineResponse, ReturnType<typeof getPaymentTimelineQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPaymentTimeline({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPaymentTimelineQueryKey(options)
});

export const listOnboardingQueueQueryKey = (options?: Options<ListOnboardingQueueData>) => createQueryKey('listOnboardingQueue', options);

export const listOnboardingQueueOptions = (options?: Options<ListOnboardingQueueData>) => queryOptions<ListOnboardingQueueResponse, ListOnboardingQueueError, ListOnboardingQueueResponse, ReturnType<typeof listOnboardingQueueQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOnboardingQueue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOnboardingQueueQueryKey(options)
});

export const listActionTypesQueryKey = (options?: Options<ListActionTypesData>) => createQueryKey('listActionTypes', options);

export const listActionTypesOptions = (options?: Options<ListActionTypesData>) => queryOptions<ListActionTypesResponse, ListActionTypesError, ListActionTypesResponse, ReturnType<typeof listActionTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listActionTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listActionTypesQueryKey(options)
});

export const listActionsQueryKey = (options?: Options<ListActionsData>) => createQueryKey('listActions', options);

export const listActionsOptions = (options?: Options<ListActionsData>) => queryOptions<ListActionsResponse, ListActionsError, ListActionsResponse, ReturnType<typeof listActionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listActions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listActionsQueryKey(options)
});

/**
 * Requests an act-on-behalf change with a reason. Changes that loosen a control wait
 * for a second staff member's approval; the rest run immediately.
 *
 */
export const requestActionMutation = (options?: Partial<Options<RequestActionData>>): UseMutationOptions<RequestActionResponse, RequestActionError, Options<RequestActionData>> => {
    const mutationOptions: UseMutationOptions<RequestActionResponse, RequestActionError, Options<RequestActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await requestAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const decideActionMutation = (options?: Partial<Options<DecideActionData>>): UseMutationOptions<DecideActionResponse, DecideActionError, Options<DecideActionData>> => {
    const mutationOptions: UseMutationOptions<DecideActionResponse, DecideActionError, Options<DecideActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await decideAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listViewAsQueryKey = (options?: Options<ListViewAsData>) => createQueryKey('listViewAs', options);

export const listViewAsOptions = (options?: Options<ListViewAsData>) => queryOptions<ListViewAsResponse, ListViewAsError, ListViewAsResponse, ReturnType<typeof listViewAsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listViewAs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listViewAsQueryKey(options)
});

/**
 * Opens a read-only, time-boxed view-as session. Write access is requested as the impersonation.write action.
 */
export const startViewAsMutation = (options?: Partial<Options<StartViewAsData>>): UseMutationOptions<StartViewAsResponse, StartViewAsError, Options<StartViewAsData>> => {
    const mutationOptions: UseMutationOptions<StartViewAsResponse, StartViewAsError, Options<StartViewAsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startViewAs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const endViewAsMutation = (options?: Partial<Options<EndViewAsData>>): UseMutationOptions<EndViewAsResponse, EndViewAsError, Options<EndViewAsData>> => {
    const mutationOptions: UseMutationOptions<EndViewAsResponse, EndViewAsError, Options<EndViewAsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await endViewAs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reissues the link for an active session the caller owns.
 */
export const issueViewAsTokenMutation = (options?: Partial<Options<IssueViewAsTokenData>>): UseMutationOptions<IssueViewAsTokenResponse, IssueViewAsTokenError, Options<IssueViewAsTokenData>> => {
    const mutationOptions: UseMutationOptions<IssueViewAsTokenResponse, IssueViewAsTokenError, Options<IssueViewAsTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await issueViewAsToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listBreaksQueryKey = (options?: Options<ListBreaksData>) => createQueryKey('listBreaks', options);

export const listBreaksOptions = (options?: Options<ListBreaksData>) => queryOptions<ListBreaksResponse, ListBreaksError, ListBreaksResponse, ReturnType<typeof listBreaksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listBreaks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBreaksQueryKey(options)
});

export const resolveBreakMutation = (options?: Partial<Options<ResolveBreakData>>): UseMutationOptions<ResolveBreakResponse, ResolveBreakError, Options<ResolveBreakData>> => {
    const mutationOptions: UseMutationOptions<ResolveBreakResponse, ResolveBreakError, Options<ResolveBreakData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resolveBreak({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listReconRunsQueryKey = (options?: Options<ListReconRunsData>) => createQueryKey('listReconRuns', options);

export const listReconRunsOptions = (options?: Options<ListReconRunsData>) => queryOptions<ListReconRunsResponse, ListReconRunsError, ListReconRunsResponse, ReturnType<typeof listReconRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listReconRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listReconRunsQueryKey(options)
});

export const runReconMutation = (options?: Partial<Options<RunReconData>>): UseMutationOptions<unknown, RunReconError, Options<RunReconData>> => {
    const mutationOptions: UseMutationOptions<unknown, RunReconError, Options<RunReconData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runRecon({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPartnersQueryKey = (options?: Options<ListPartnersData>) => createQueryKey('listPartners', options);

export const listPartnersOptions = (options?: Options<ListPartnersData>) => queryOptions<ListPartnersResponse, ListPartnersError, ListPartnersResponse, ReturnType<typeof listPartnersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPartners({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPartnersQueryKey(options)
});

/**
 * Forces a partner's circuit up or down (or clears the override with an empty state).
 */
export const setPartnerOverrideMutation = (options?: Partial<Options<SetPartnerOverrideData>>): UseMutationOptions<SetPartnerOverrideResponse, SetPartnerOverrideError, Options<SetPartnerOverrideData>> => {
    const mutationOptions: UseMutationOptions<SetPartnerOverrideResponse, SetPartnerOverrideError, Options<SetPartnerOverrideData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setPartnerOverride({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPartnerEventsQueryKey = (options?: Options<ListPartnerEventsData>) => createQueryKey('listPartnerEvents', options);

export const listPartnerEventsOptions = (options?: Options<ListPartnerEventsData>) => queryOptions<ListPartnerEventsResponse, ListPartnerEventsError, ListPartnerEventsResponse, ReturnType<typeof listPartnerEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPartnerEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPartnerEventsQueryKey(options)
});

export const searchAuditQueryKey = (options?: Options<SearchAuditData>) => createQueryKey('searchAudit', options);

export const searchAuditOptions = (options?: Options<SearchAuditData>) => queryOptions<SearchAuditResponse, SearchAuditError, SearchAuditResponse, ReturnType<typeof searchAuditQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchAudit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchAuditQueryKey(options)
});

export const searchAuditInfiniteQueryKey = (options?: Options<SearchAuditData>): QueryKey<Options<SearchAuditData>> => createQueryKey('searchAudit', options, true);

export const searchAuditInfiniteOptions = (options?: Options<SearchAuditData>) => {
    const opts = infiniteQueryOptions<SearchAuditResponse, SearchAuditError, InfiniteData<SearchAuditResponse>, QueryKey<Options<SearchAuditData>>, string | Pick<QueryKey<Options<SearchAuditData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<SearchAuditData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await searchAudit({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchAuditInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};
